<ng-container *ngIf="currentTarget === targetChoicesEnum.SCHOOL">
    <p class="disclaimer-text">{{ 'SHARED.CHANGE_SCHOOL_DISCLAIMER_P1' | translate }}</p>
    <p class="disclaimer-text">{{ 'SHARED.CHANGE_SCHOOL_DISCLAIMER_P2' | translate }}</p>
</ng-container>

<ng-container *ngIf="currentTarget === targetChoicesEnum.LOGOUT || currentTarget === targetChoicesEnum.LOGOUT_PREVENT_BACK">
    <p class="disclaimer-text">{{ 'SHARED.LOGOUT_DISCLAIMER_P1' | translate }}</p>
    <p *ngIf="currentTarget === targetChoicesEnum.LOGOUT_PREVENT_BACK" class="disclaimer-text">
        {{ 'SHARED.LOGOUT_DISCLAIMER_MODIFIED_DATA' | translate }}
    </p>
</ng-container>

<ng-container
    *ngIf="
        currentTarget === targetChoicesEnum.ROUTING ||
        currentTarget === targetChoicesEnum.IMPERSONATE ||
        currentTarget === targetChoicesEnum.MODIFIED_FORM
    "
>
    <p class="disclaimer-text">{{ 'SHARED.MODIFIED-DATA-P1' | translate }}</p>
    <p class="disclaimer-text">{{ 'SHARED.MODIFIED-DATA-P2' | translate }}</p>
</ng-container>

<p class="disclaimer-text" *ngIf="currentTarget !== targetChoicesEnum.LOGOUT && currentTarget !== targetChoicesEnum.LOGOUT_PREVENT_BACK">
    {{ 'SHARED.MODIFIED-DATA-P3' | translate }}
</p>
